<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Investors Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investors/contracts'"
            >Investors</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <span
        class="col-1"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        "
      >
        <i
          class="fa fa-filter"
          style="font-size: 15px; color: #8cc63f; margin-right: 5px"
        ></i>
        Filter
      </span>
      <span class="col-3">
        <input
          type="text"
          class="form-control"
          placeholder="Keyword"
          v-model="keyword"
          @change="filter()"
          style="padding: 10px"
        />
      </span>
      <span class="col-4">
        <select
          class="custom-select"
          v-model="investor_id"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!investor_id" :value="null" disabled selected>
            Select Investor ID
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option
            v-for="investor in investors"
            :key="investor.code"
            :value="investor.id"
          >
            {{ investor.code }}
          </option>
        </select>
      </span>
      <span class="col-4">
        <select
          class="custom-select"
          v-model="status"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!status" :value="null" disabled selected>
            Select a Status
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option
            v-for="status in statusList"
            :key="status.name"
            :value="status.id"
          >
            {{ status.name }}
          </option>
        </select>
      </span>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="redirectToCreateInvestor()"
      >
        <div>
          <i
            class="fa fa-plus-circle"
            style="font-size: 90px; color: #8cc63f; margin-right: 5px"
          ></i>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <p
            style="
              margin: 0px;
              font-size: 40px;
              margin-bottom: 5px;
              color: #8cc63f;
            "
          >
            ADD
          </p>
          <p style="margin: 0; color: #8cc63f; font-size: 14px">new investor</p>
        </div>
      </div>
    </div>
    <div
      style="
        margin-top: 50px;
        display: flex;
        justify-content: end;
        padding: 0 60px;
      "
    >
      <input
        id="showHidden"
        v-model="showHidden"
        type="checkbox"
        style="height: 20px; width: 20px"
      />
      <span style="margin-left: 5px" for="showHidden">Show Hidden</span>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 10px">
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          max-width: 90%;
          border-radius: 15px;
          padding: 40px;
          margin: 0;
        "
      >
        <table style="text-align: center">
          <thead>
            <tr>
              <th>Client ID</th>
              <th style="cursor: pointer" @click="toggleShowInvestorName()">
                Client Name
              </th>
              <th
                style="cursor: pointer"
                @click="toggleShowInvestorNationality()"
              >
                Nationality
              </th>
              <th
                style="cursor: pointer"
                @click="toggleShowInvestorResidence()"
              >
                Country of Residence
              </th>
              <th>Phone Number</th>
              <th>Status</th>
              <!-- <th>Address</th> -->
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(investor, index) in investors" :key="index">
              <td>
                <router-link
                  style="color: black !important; font-weight: bold"
                  :to="
                    '/' +
                    authUser.userable_type +
                    '/investor/' +
                    investor.code +
                    '/' +
                    investor.id
                  "
                >
                  {{ investor.code }}</router-link
                >
              </td>
              <td v-if="showHidden">
                {{ investor.first_name }} {{ investor.last_name }}
              </td>
              <td v-else>******</td>
              <td v-if="showHidden">
                {{ investor.nationality.name }}
              </td>
              <td v-else>******</td>
              <td v-if="showHidden">
                {{ investor.residence.name }}
              </td>
              <td v-else>******</td>
              <td v-if="showHidden">
                {{ investor.mobile_number }}
              </td>
              <td v-else>******</td>
              <td>{{ investor.enabled ? "Active" : "Inactive" }}</td>
              <!-- <td>{{ investor.home_address }}</td> -->
              <!-- <td>
                <i
                  style="cursor: pointer"
                  @click="redirectToInvestor(investor)"
                  class="fa fa-eye"
                ></i>
              </td> -->
            </tr>
          </tbody>
        </table>
      </md-card>
    </div>
  </div>
</template><script>
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import InvestorsFilter from "../../filters/InvestorsFilter";

export default {
  name: "investor",
  data() {
    return {
      selectedInvestorId: null,
      actionModalType: null,
      showInvestorModal: false,
      showInvestorName: false,
      showInvestorNationality: false,
      showInvestorResidence: false,
      showHidden: false,
      columns: [],
      statusList: [
        { id: 1, name: "Active" },
        { id: 0, name: "InActive" },
      ],
      status: null,
      keyword: null,
      investor_id: null,
    };
  },
  components: {},
  created: function () {
    var investorsFilter = InvestorsFilter();
    investorsFilter.with = ["residence", "nationality"];
    this.$store.dispatch("searchInvestors", {
      filter: investorsFilter,
      resultMode: "default",
    });
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      investors: (state) => state.investorStore.investorSearch.investors,
      createInvestorStatus: (state) =>
        state.investorStore.investorCreate.createInvestorStatus,
      updateInvestorStatus: (state) =>
        state.investorStore.investorUpdate.updateInvestorStatus,
      deleteInvestorStatus: (state) =>
        state.investorStore.investorDelete.deleteInvestorStatus,
    }),
  },
  methods: {
    init() {
      this.selectedInvestorId = null;
      this.actionModalType = null;
      this.showInvestorModal = false;
      this.$store.dispatch("searchInvestor");
    },
    clearDateRage() {
      this.filter();
    },
    toggleShowInvestorName() {
      this.showInvestorName = !this.showInvestorName;
    },
    toggleShowInvestorNationality() {
      this.showInvestorNationality = !this.showInvestorNationality;
    },
    toggleShowInvestorResidence() {
      this.showInvestorResidence = !this.showInvestorResidence;
    },
    filter() {
      var investorsFilter = InvestorsFilter();
      investorsFilter.name = this.keyword;
      investorsFilter.is_enabled = this.status;
      if (this.investor_id) {
        investorsFilter.ids = [this.investor_id];
      }
      this.$store.dispatch("searchInvestors", {
        filter: investorsFilter,
        resultMode: "default",
      });
    },
    handleSave(investor) {
      if (this.actionModalType == "createModal") {
        this.createInvestor(investor);
      } else {
        this.updateInvestor(investor);
      }
    },
    redirectToCreateInvestor() {
      this.$router.push(
        "/" + this.authUser.userable_type + "/investors/create"
      );
    },
    redirectToInvestor(investor) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/investor/" +
          investor.code +
          "/" +
          investor.id
      );
    },
    createInvestor(investor) {
      this.$store.dispatch("createInvestor", investor);
    },
    updateInvestor(investor) {
      this.$store.dispatch("updateInvestor", investor);
    },
    deleteInvestor(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this investor?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteInvestor", id);
        }
      });
    },
    toggleCreateInvestorModal() {
      this.showInvestorModal = !this.showInvestorModal;
      this.showInvestorModal ? (this.actionModalType = "createModal") : null;
    },
    toggleUpdateInvestorModal(id = null) {
      this.showInvestorModal = !this.showInvestorModal;
      if (this.showInvestorModal) {
        this.actionModalType = "updateModal";
        this.selectedInvestorId = id;
      } else {
        this.actionModalType = null;
        this.selectedInvestorId = null;
      }
    },
  },
  watch: {
    createInvestorStatus() {
      if (this.createInvestorStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Investor has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createInvestorStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Investor creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updateInvestorStatus() {
      if (this.updateInvestorStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Investor has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updateInvestorStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Investor update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    deleteInvestorStatus() {
      if (this.deleteInvestorStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Investor has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.deleteInvestorStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Investor delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  background-color: rgb(250, 250, 247) !important;
}
.custom-select {
  background-color: #fafaf7;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/investors.vue